import {useSortable} from "@dnd-kit/sortable";
import classNames from "classnames";
import {HiMenuAlt4} from "react-icons/hi";

import {IconButton} from "@/components/iconButton/IconButton.tsx";

import styles from "./TableRowDragHandleCell.module.scss";

export const TableRowDragHandleCell = ({rowId, ...rest}: {rowId: string; disabled?: boolean}) => {
  const {attributes, listeners} = useSortable({
    id: rowId,
  });
  return (
    <IconButton
      icon={HiMenuAlt4}
      variant={"ghost"}
      size={"fitIcon"}
      className={classNames({[styles.dragHandleDisabled]: rest.disabled}, "pulse-color-gray-600")}
      {...rest}
      {...attributes}
      {...listeners}
    />
  );
};
